export const eApplicationMenus = () => ({
    id: `main-menu-2-all`,
    path: '/e-applications/home',
    label: 'eApplications',
    Description: 'E-Apps can also track and observe Employee, Finance etc and use it to offer custom recommendations and updates to the users. Furthermore.',
    isEnabled: true,
    svg: (
        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M20 3h-3V2H7v1H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V7h16v14zm-6-9h-4v-1h4v1zm-6 2h6v1H8v-1zm6-4H8v-1h6v1z" />
            </g>
        </svg>

    ),

    subMenu: [
        {
            id: `main-menu-2-all`,
            path: '/management/e-applications/hrms/employees',
            label: 'HRMS',
            Description: 'HRMS stands for Human Resources Management System. It refers to a suite of software that organizations use to manage internal HR functions',
            isEnabled: true,
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zm-6-4h-4v-1h4v1zm0 2h-4v-1h4v1zm0 2h-4v-1h4v1z" fill="#007BFF"></path>
                    </g>
                </svg>
            ),

            subMenu: [
                {
                    id: `coln-1-collections`,
                    label: 'Employees',
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-1 12H5V8h14v8zM7 10h10v1H7v-1zm0 2h10v1H7v-1zm0 2h6v1H7v-1zm8-6v1H5V6h10z" fill="#007BFF"></path>
                            </g>
                        </svg>
                    ),
                    path: '/management/e-applications/hrms/employees',
                    isEnabled: true,

                },
                {
                    id: `coln-1-collections`,
                    label: 'Departments',
                    path: '/management/e-applications/hrms/departments',
                    isEnabled: true,
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zm-6-4h-4v-1h4v1zm0 2h-4v-1h4v1zm0 2h-4v-1h4v1z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-Categories`,
                    label: 'Designations',
                    path: '/management/e-applications/hrms/designations',
                    isEnabled: true,
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zM7 10h10v1H7v-1zm0 2h10v1H7v-1zm0 2h6v1H7v-1zm8-6v1H5V6h10z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-Categories`,
                    label: 'Payrolls',
                    path: '/management/e-applications/hrms/payrolls',
                    isEnabled: true,
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zM7 10h10v1H7v-1zm0 2h10v1H7v-1zm0 2h6v1H7v-1zm8-6v1H5V6h10z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-Categories`,
                    label: 'OnBoarding',
                    path: '/management/e-applications/hrms/onBoarding',
                    isEnabled: true,
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zm-6-4h-4v-1h4v1zm0 2h-4v-1h4v1zm0 2h-4v-1h4v1z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-Categories`,
                    label: 'Attendence',
                    path: '/management/e-applications/hrms/attendence',
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-1 12H5V8h14v8zM7 10h10v1H7v-1zm0 2h10v1H7v-1zm0 2h6v1H7v-1zm8-6v1H5V6h10z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                    isEnabled: true,
                },
            ],
        },
        {
            id: `main-menu-2-all`,
            path: '/management/e-applications/tax-management/tax-ledgers',
            label: 'Tax Management',
            Description: 'Tax Management streamlines and automates the tasks involved with configuring, collecting, managing, and reporting tax ',
            isEnabled: true,
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zm-6-4h-4v-1h4v1zm0 2h-4v-1h4v1zm0 2h-4v-1h4v1z" fill="#007BFF"></path>
                    </g>
                </svg>

            ),

            subMenu: [

                {
                    id: `coln-1-Categories`,
                    label: 'Tax Ledger',
                    path: '/management/e-applications/tax-management/tax-ledgers',
                    isEnabled: true,
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zm-6-4h-4v-1h4v1zm0 2h-4v-1h4v1zm0 2h-4v-1h4v1z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-Categories`,
                    label: 'Tax Providers',
                    path: '/management/e-applications/tax-management/tax-providers',
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zm-6-4h-4v-1h4v1zm0 2h-4v-1h4v1zm0 2h-4v-1h4v1z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                    isEnabled: true,
                },
                {
                    id: `coln-1-Categories`,
                    label: 'Tax Settings',
                    path: '/management/e-applications/tax-management/tax-settings',
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zM7 10h10v1H7v-1zm0 2h10v1H7v-1zm0 2h6v1H7v-1zm8-6v1H5V6h10z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                    isEnabled: true,
                },
            ],
        },
        {
            id: `main-menu-2-all`,
            path: '/management/e-applications/fms/payouts',
            label: 'FMS',
            Description: 'FMS manages financial functions for businesses. Finance and accounting teams use accounting tools to manage expense and cash flow, as well as functions like billing, payroll, general ledger, accounts receivable, and accounts payable',
            isEnabled: true,
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zM7 10h10v1H7v-1zm0 2h10v1H7v-1zm0 2h6v1H7v-1zm8-6v1H5V6h10z" fill="#007BFF"></path>
                    </g>
                </svg>

            ),

            subMenu: [

                {
                    id: `coln-1-Categories`,
                    label: 'Payouts',
                    path: '/management/e-applications/fms/payouts',
                    isEnabled: true,
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zM7 10h10v1H7v-1zm0 2h10v1H7v-1zm0 2h6v1H7v-1zm8-6v1H5V6h10z" fill="#007BFF"></path>
                            </g>
                        </svg>
                    ),
                },

            ],
        },
        {
            id: `main-menu-2-all`,
            path: '/management/e-applications/contract/terms-libraries',
            label: 'Contract',
            Description: 'Contract management software allows organizations of all sizes and kinds to create, store, and manage contracts throughout their entire lifecycle ',
            isEnabled: true,
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zm-6-4h-4v-1h4v1zm0 2h-4v-1h4v1zm0 2h-4v-1h4v1z" fill="#007BFF"></path>
                    </g>
                </svg>

            ),

            subMenu: [

                {
                    id: `coln-1-Categories`,
                    label: 'Terms Library',
                    path: '/management/e-applications/contract/terms-libraries',
                    isEnabled: true,
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zm-6-4h-4v-1h4v1zm0 2h-4v-1h4v1zm0 2h-4v-1h4v1z" fill="#007BFF"></path>
                            </g>
                        </svg>

                    ),
                },
                {
                    id: `coln-1-Categories`,
                    label: 'Sections',
                    path: '/management/e-applications/contract/sections',
                    isEnabled: true,
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path fillRule="evenodd" clipRule="evenodd" d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H5V7h14v10zM7 10h10v1H7v-1zm0 2h10v1H7v-1zm0 2h6v1H7v-1zm8-6v1H5V6h10z" fill="#007BFF"></path>
                            </g>
                        </svg>
                    ),
                },
            ],
        },
    ]
}
)
